import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import moment from 'moment'
import { IModalBase } from '@interfaces/commonInterfaces'

export interface IState {
  notificationList?: any
  notificationOptionList?: any
  notificationDetail?: any
  reloadNotificationList?: string | null
  modalNotification?: IModalBase
}

const initialState: IState = {
  notificationList: [],
  notificationOptionList: [],
  notificationDetail: {},
  reloadNotificationList: null,
  modalNotification: {
    visible: false,
    record: {}
  }
}

export const notificationDucks = createSlice({
  name: 'notification',
  initialState,
  reducers: {

    getListNotification: (state: RootState, action: PayloadAction<any>) => {
      state.notificationList = { loading: true, queryStr: action.payload }
    },
    getListNotificationSuccess: (state, action: PayloadAction<any>) => {
      state.notificationList = { loading: false, ...action.payload }
    },
    getListNotificationFail: (state, action: PayloadAction<any>) => {
      state.notificationList = { loading: false, ...action.payload }
    },

    getListOptionNotification: (state: RootState, action: PayloadAction<any>) => {
      state.notificationOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionNotificationSuccess: (state, action: PayloadAction<any>) => {
      state.notificationOptionList = { loading: false, ...action.payload }
    },
    getListOptionNotificationFail: (state, action: PayloadAction<any>) => {
      state.notificationOptionList = { loading: false, ...action.payload }
    },

    getDetailNotification: (state: RootState, action: PayloadAction<any>) => {
      state.notificationDetail = { loading: true, id: action.payload }
    },
    getDetailNotificationSuccess: (state, action: PayloadAction<any>) => {
      state.notificationDetail = { loading: false, ...action.payload }
    },
    getDetailNotificationFail: (state, action: PayloadAction<any>) => {
      state.notificationDetail = { loading: false, ...action.payload }
    },

    setReloadNotificationList: (state: RootState) => {
      state.reloadNotificationList = String(moment())
    },
    setModalNotification: (state, action: PayloadAction<IModalBase>) => {
      state.modalNotification = action.payload
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListNotification,
  getListNotificationSuccess,
  getListNotificationFail,

  getListOptionNotification,
  getListOptionNotificationSuccess,
  getListOptionNotificationFail,

  getDetailNotification,
  getDetailNotificationSuccess,
  getDetailNotificationFail,

  setReloadNotificationList,
  setModalNotification
} = notificationDucks.actions

export default notificationDucks.reducer
